import React from 'react'
import classnames from 'classnames'
import { getAriaLabel } from 'shared/lib'
import styles from './styles.module.scss'

enum statusSizeEnum {
  md = 'md',
  lg = 'lg',
}

type IStatusProps = {
  online?: boolean
  size?: number
}

export const OnlineStatus: React.FC<IStatusProps> = ({ online, size }) => {
  const statusSize =
    typeof online === 'boolean'
      ? size === 32
        ? statusSizeEnum.lg
        : size === 24 || size === 16
        ? statusSizeEnum.md
        : null
      : null

  if (!statusSize) return null

  return (
    <div
      className={classnames(styles.status, styles[`${statusSize}`], {
        [styles.offline]: !online,
      })}
      aria-label={getAriaLabel('Avatar', 'OnlineStatus')}
    >
      <div />
    </div>
  )
}
